<div *ngIf="unitLoading" class="ump-loading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<ng-container *ngIf="!unitLoading">
  <mat-card class="ump-card table-surface-card">
      <mat-card-content>
        <app-table-surface
          *ngIf="!membersLoadErrorMessage"
            title="Miembros"
            titleIcon="groups"
            [columns]="columns"
            [data]="tableData"
            [isLoading]="isTableLoading"
            [enableRowHover]="false"
            [initialSort]="{ sortBy: 'lastName', direction: 'asc' }"
            [paginationConfig]="paginationConfig"
            [showPageSizeSelector]="true"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [noDataMessage]="'No se encontraron miembros.'"
            [cellTemplate]="cellContent"
            [mobileCardTemplate]="mobileMemberCard"
            [activeFilters]="activeFilterChips"
            tableId="unit-members-page-v3"
            [enableSearch]="true"
            searchPlaceholder="Buscar miembro..."
            [enableFilter]="true"
            [enableSort]="true"
            [sortState]="currentSort"
            [enableColumnVisibility]="true"
            [enableDensity]="true"
            primaryActionLabel="Nuevo"
            [readonly]="!canManageMemberData"
            (sortChange)="onSortChange($event)"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"
            (searchChange)="onToolbarSearch($event)"
            (filterRemove)="onFilterRemove($event)"
            (toolbarSortChange)="onToolbarSort($event)"
            (primaryActionClick)="createMember()">
            <div filterPanel class="ump-filter-panel" [formGroup]="filterForm">
              <app-data-table-multi-select-filter formControlName="status" label="Estado" [options]="membershipStatusOptions"></app-data-table-multi-select-filter>

              <app-data-table-multi-select-filter formControlName="ageStatus" label="Edad" [options]="ageStatusOptions" [groups]="ageStatusGroups"></app-data-table-multi-select-filter>

              <app-data-table-multi-select-filter formControlName="ministry" label="Ministerio" [options]="ministrySelectOptions"></app-data-table-multi-select-filter>

              <app-data-table-multi-select-filter formControlName="ministryStatus" label="Estado del ministerio" [options]="ministryStatusOptions"></app-data-table-multi-select-filter>

              <app-data-table-multi-select-filter *ngIf="showCommunityFilter" formControlName="community" label="Comunidad" [options]="communitySelectOptions"></app-data-table-multi-select-filter>

              <app-data-table-multi-select-filter formControlName="responsiblePriest" label="Pastor de hogar" [options]="responsiblePriestSelectOptions"></app-data-table-multi-select-filter>
            </div>
        </app-table-surface>

        <div *ngIf="membersLoadErrorMessage" class="ump-error-state">
          <mat-icon>error_outline</mat-icon>
          <div class="ump-error-state__content">
            <strong>No se pudo cargar la lista de miembros</strong>
            <span>{{ membersLoadErrorMessage }}</span>
          </div>
          <button mat-stroked-button color="primary" type="button" (click)="retryMembers()">
            <mat-icon>refresh</mat-icon>
            <span>Refrescar</span>
          </button>
        </div>

        <ng-template #cellContent let-column="column" let-row="row">
          <span *ngIf="column === 'firstName'">{{ row.firstName }}</span>
          <span *ngIf="column === 'lastName'">{{ row.lastName }}</span>
          <app-membership-status-badge *ngIf="column === 'status'" [status]="row.status"></app-membership-status-badge>
          <span *ngIf="column === 'phone'" class="ump-phone">{{ row.phone ? (row.phone | phoneNumber) : '-' }}</span>
          <span *ngIf="column === 'age'" class="ump-age-cell">
            <span class="ump-age-number">{{ row.age ?? '-' }}</span>
            <span *ngIf="row.ageStatus" class="ump-secondary-status">{{ getAgeStatusLabel(row.ageStatus) }}</span>
          </span>
          <ng-container *ngIf="column === 'community'">
            <a *ngIf="row.communityUnitId" [routerLink]="['/units', row.communityUnitId]" class="ump-community-link" (click)="$event.stopPropagation()">{{ row.communityName }}</a>
            <span *ngIf="!row.communityUnitId">{{ row.communityName || '-' }}</span>
          </ng-container>
          <span *ngIf="column === 'ministry'" class="ump-ministry">
            <span *ngIf="!row.ministryName">-</span>
            <ng-container *ngIf="row.ministryName">
              <span *ngIf="row.ministryStatus !== 'Active' || hasActiveMinistryInCurrentUnit(row)">{{ row.ministryName }}</span>
              <span *ngIf="row.ministryStatus === 'Active' && !hasActiveMinistryInCurrentUnit(row)">-</span>
              <span *ngIf="hasActiveMinistryInOtherUnits(row)" class="ump-ministry-other-units" matTooltip="Activa en otra comunidad">
                <mat-icon>church</mat-icon>
                <span>+</span>
              </span>
              <span *ngIf="row.ministryStatus && row.ministryStatus !== 'Active'" class="ump-secondary-status">{{ getMinistryStatusLabel(row.ministryStatus) }}</span>
            </ng-container>
          </span>
          <span *ngIf="column === 'responsiblePriest'" class="ump-responsible-priest">
            <app-member-reference
              *ngIf="row.responsiblePriestName; else noResponsiblePriest"
              [personId]="row.responsiblePriestId"
              [name]="row.responsiblePriestName"
              [stopPropagation]="true"></app-member-reference>
            <ng-template #noResponsiblePriest>-</ng-template>
          </span>
          <ng-container *ngIf="column === 'actions'">
            <ng-container *ngTemplateOutlet="memberActionsTemplate; context: { $implicit: row, mobile: false }"></ng-container>
          </ng-container>
        </ng-template>

        <ng-template #memberActionsTemplate let-row let-mobile="mobile">
            <span class="ump-member-actions">
            <ng-container *ngIf="mobile">
              <a *ngIf="phoneLink(row.phone) as phone; else noPhone" mat-icon-button class="ump-mobile-call"
                [href]="phone" [attr.aria-label]="'Llamar a ' + row.firstName + ' ' + row.lastName"
                [matTooltip]="row.phone | phoneNumber" (click)="$event.stopPropagation()"><mat-icon>call</mat-icon></a>
              <ng-template #noPhone><button mat-icon-button class="ump-mobile-call" type="button" disabled
                [attr.aria-label]="row.firstName + ' ' + row.lastName + ': sin teléfono'" matTooltip="Sin teléfono registrado"><mat-icon>call</mat-icon></button></ng-template>
            </ng-container>
            <button
              *ngIf="!mobile"
              mat-icon-button
              type="button"
              aria-label="Ver ficha del miembro"
              matTooltip="Ver ficha del miembro"
              (click)="openMemberProfile(row, $event)">
              <mat-icon>person</mat-icon>
            </button>
            <ng-container *ngIf="canManageMemberData">
            <button
              mat-icon-button
              type="button"
              aria-label="Acciones del miembro"
              [matMenuTriggerFor]="memberActions"
              (click)="$event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #memberActions="matMenu">
              <button mat-menu-item type="button" (click)="navigateToMemberEdit(row, $event)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item type="button" (click)="navigateToMemberEvents(row, $event)">
                <mat-icon>volunteer_activism</mat-icon>
                <span>Actividad e Hitos</span>
              </button>
              <button mat-menu-item type="button" (click)="navigateToMemberCommunityHistory(row, $event)">
                <mat-icon>swap_horiz</mat-icon>
                <span>Pases de comunidad</span>
              </button>
              <button mat-menu-item type="button" (click)="changeMemberStatus(row, $event)">
                <mat-icon>published_with_changes</mat-icon>
                <span>Cambiar estado</span>
              </button>
              <button mat-menu-item type="button" (click)="toggleHomeAttendance(row, $event)">
                <mat-icon [svgIcon]="row.isHomeAttended ? 'not-home-attendance' : 'home-attendance'"></mat-icon>
                <span>{{ row.isHomeAttended ? 'Quitar atención en el hogar' : 'Marcar como atendido en el hogar' }}</span>
              </button>
              <button *ngIf="isAdmin && !row.hasLinkedUser" mat-menu-item type="button" (click)="createUserForMember(row, $event)">
                <mat-icon>person_add</mat-icon>
                <span>Crear usuario</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item type="button" (click)="manageResponsiblePriest(row, $event)">
                <mat-icon>volunteer_activism</mat-icon>
                <span>Modificar pastor de hogar</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item type="button" class="danger-menu-item" (click)="deleteMember(row, $event)">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
            </ng-container>
            </span>
        </ng-template>

        <ng-template #mobileMemberCard let-row>
          <div class="ump-mobile-member">
            <a class="ump-mobile-avatar" [routerLink]="['/units', unitId, 'members', row.id]"
              [attr.aria-label]="'Ver ficha de ' + row.firstName + ' ' + row.lastName" (click)="$event.stopPropagation()">
              <mat-icon>person</mat-icon>
              <img *ngIf="row.photo && !failedMemberPhotos.has(row.photo)"
                [appAuthenticatedPhoto]="row.photo" alt="" loading="lazy" (error)="failedMemberPhotos.add(row.photo)">
            </a>
            <div class="ump-mobile-details">
            <div class="ump-mobile-top">
              <div class="ump-mobile-identity">
                <a class="ump-mobile-name" [routerLink]="['/units', unitId, 'members', row.id]" (click)="$event.stopPropagation()">
                  {{ row.firstName }} {{ row.lastName }}
                </a>
                <span *ngIf="row.isHomeAttended" class="ump-mobile-home" role="img" aria-label="Atendido en el hogar" matTooltip="Atendido en el hogar">
                  <mat-icon svgIcon="home-attendance"></mat-icon>
                </span>
              </div>
              <ng-container *ngTemplateOutlet="memberActionsTemplate; context: { $implicit: row, mobile: true }"></ng-container>
            </div>
            <div class="ump-mobile-facts">
              <span *ngIf="row.age !== null && row.age !== undefined" class="ump-mobile-fact">{{ row.age }} {{ row.age === 1 ? 'año' : 'años' }}</span>
              <span *ngIf="row.ministryName && (row.ministryStatus !== 'Active' || hasActiveMinistryInCurrentUnit(row))" class="ump-mobile-ministry">
                {{ row.ministryName }}<span *ngIf="row.ministryStatus && row.ministryStatus !== 'Active'" class="ump-secondary-status">{{ getMinistryStatusLabel(row.ministryStatus) }}</span>
              </span>
              <span *ngIf="hasActiveMinistryInOtherUnits(row)" class="ump-mobile-ministry" matTooltip="Ministerio activo en otra comunidad">Ministerio en otra comunidad</span>
            </div>
            <div *ngIf="row.status && row.status !== 'Active'" class="ump-mobile-badges">
              <app-membership-status-badge *ngIf="row.status && row.status !== 'Active'" [status]="row.status"></app-membership-status-badge>
            </div>
            <a *ngIf="showCommunityFilter && row.communityName && row.communityUnitId" class="ump-mobile-community"
              [routerLink]="['/units', row.communityUnitId]" (click)="$event.stopPropagation()">{{ row.communityName }}</a>
            <span *ngIf="showCommunityFilter && row.communityName && !row.communityUnitId" class="ump-mobile-community">{{ row.communityName }}</span>
            <div *ngIf="row.responsiblePriestName" class="ump-mobile-priest">
              <span>Pastor de hogar:</span>
              <app-member-reference [personId]="row.responsiblePriestId" [name]="row.responsiblePriestName" [stopPropagation]="true"></app-member-reference>
            </div>
            </div>
          </div>
        </ng-template>
      </mat-card-content>
  </mat-card>
</ng-container>
